import { openModal } from '../actions';
import { ModalDataInfoType } from './types';

export const openInfoModal = (data: ModalDataInfoType) =>
  openModal('INFO', { data });
